export default __webpack_public_path__ + "static/media/st_help3.13b3c49d.png";